<template>
  <div>
    <h1>Upload Extract</h1>
    <p>Use this view to upload the extract from the bank</p>

    <v-tabs v-model="tab">
      <v-tab>Files</v-tab>
      <v-tab>Upload</v-tab>
      <v-tab>Consolidate</v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item>
        <div>
          <div v-for="file in files" :key="file.id">
            <div style="border-bottom: 1px solid #ccc; margin: 5px; padding: 5px 0px">
              {{ file.Key }}
              <br />
              {{ file.LastModified }}
              <br />
              <div style="display: flex; justify-content: space-between">
                <a :href="file.signed_url" target="_blank">download</a>

                <div>
                  <v-btn @click="deleteFile(file.Key)">delete</v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-tab-item>
      <v-tab-item>
        <!-- parse bank -->
        <div>
          <ParseBank @done="bankData = $event" />
          <div v-if="bankData.length > 0">
            <h2>Parsed Data</h2>

            <div>
              <div>bankData.length: {{ bankData.length }}</div>
              <div v-for="row in bankData" :key="row.hash">
                <MovementListItem :item="row" />
              </div>
            </div>
            <pre>{{ bankData }}</pre>
          </div>
        </div>
      </v-tab-item>

      <!-- consolidate -->
      <v-tab-item>
        <div>
          <v-btn @click="consolidate" block depressed :loading="loading">Consolidate</v-btn>
        </div>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import api from '@/assets/api'

import ParseBank from './ParseBank.vue'
import MovementListItem from './MovementListItem.vue'
import { v4 as uuidv4 } from 'uuid'

export default {
  name: 'ExpensesUpload',
  components: {
    ParseBank,
    MovementListItem,
  },
  computed: {
    filename() {
      return uuidv4()
    },
  },
  data() {
    return {
      files: [],
      tab: 0,
      bankData: [],
      loading: false,
    }
  },
  methods: {
    async consolidate() {
      //fetches the merged file with forceRefresh so it consolidates stuff
      this.loading = true
      let x = await api.apiFetch('/expenses/merged?type=bank&refresh=1')
      let x2 = await api.apiFetch('/expenses/merged?type=crypto&refresh=1')
      if (!x.ok || !x2.ok) {
        alert('Something went wrong consolidating expenses')
      }
      let j = await x.json()
      console.log('consolidate bank', j)
      let j2 = await x2.json()
      console.log('consolidate crypto', j2)
      this.loading = false
    },
    async fetchFiles() {
      this.loading = true
      let x = await api.apiFetch('/expenses/files')
      this.loading = false

      if (!x.ok) {
        alert('Something went wrong fetching files')
      }
      let j = await x.json()
      j = j.sort((a, b) => a.Key - b.Key)
      this.files = { ...j }
    },
    async deleteFile(key) {
      this.loading = true
      let x = await api.apiFetch(`/expenses/files?key=${key}`, {
        method: 'DELETE',
      })
      if (!x.ok) {
        alert('something went wrong deleting file')
      }
      let j = await x.json()
      console.log('delete response', j)
      this.loading = false
    },
  },
  mounted() {
    this.fetchFiles()
  },
}
</script>

<style lang="scss" scoped></style>
